if (!customElements.get('product-thumbnails')) {
  customElements.define('product-thumbnails', class ProductThumbnails extends HTMLElement {
    constructor() {
      super();

      this.currentIndex = 0;
      this.isTransitioning = false;
      
      this.init();
    }

    init() {
      this.mediaItems = document.querySelectorAll('.product__media-item');
      this.thumbnails = this.querySelectorAll('.product__thumbnail');
      this.indicators = document.querySelectorAll('.product-carousel-indicator');
      this.mainGallery = document.querySelector('.product__media-list');
      this.sliderButtons = document.querySelector('.slider-buttons');
      
      if (this.mediaItems.length === 0) return;
      
      this.setupThumbnailClicks();
      this.setupIndicatorClicks();
      this.setupSwipeGestures();
      this.setupSliderButtons();
      this.setActiveMedia(0);
    }

    setupThumbnailClicks() {
      this.thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', (e) => {
          e.preventDefault();
          this.switchToMedia(index);
        });
      });
    }

    setupIndicatorClicks() {
      this.indicators.forEach((indicator) => {
        indicator.addEventListener('click', (e) => {
          e.preventDefault();
          const index = parseInt(indicator.dataset.index);
          this.switchToMedia(index);
        });
      });
    }

    setupSliderButtons() {
      if (!this.sliderButtons) return;
      
      const prevButton = this.sliderButtons.querySelector('.slider-button--prev');
      const nextButton = this.sliderButtons.querySelector('.slider-button--next');
      const counterCurrent = this.sliderButtons.querySelector('.slider-counter--current');
      
      if (prevButton) {
        prevButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.goToPrevious();
        });
      }
      
      if (nextButton) {
        nextButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.goToNext();
        });
      }
      
      // Store counter element for updates
      this.counterCurrent = counterCurrent;
    }

    setupSwipeGestures() {
      if (!this.mainGallery) return;
      
      // Touch/Swipe variables
      let startX = 0;
      let startY = 0;
      let currentX = 0;
      let distX = 0;
      let distY = 0;
      let threshold = 50; // Lower threshold for easier swiping
      let restraint = 100;
      let allowedTime = 500;
      let elapsedTime = 0;
      let startTime = 0;
      let isSwiping = false;

      // Touch Events for Mobile
      this.mainGallery.addEventListener('touchstart', (e) => {
        const touchobj = e.changedTouches[0];
        startX = touchobj.pageX;
        startY = touchobj.pageY;
        currentX = startX;
        startTime = new Date().getTime();
        isSwiping = false;
      }, { passive: false });

      this.mainGallery.addEventListener('touchmove', (e) => {
        if (this.isTransitioning) return;
        
        const touchobj = e.changedTouches[0];
        currentX = touchobj.pageX;
        distX = currentX - startX;
        distY = touchobj.pageY - startY;
        
        // Prevent default if horizontal swipe
        if (Math.abs(distX) > Math.abs(distY) && Math.abs(distX) > 10) {
          e.preventDefault();
          isSwiping = true;
        }
      }, { passive: false });

      this.mainGallery.addEventListener('touchend', (e) => {
        if (!isSwiping || this.isTransitioning) return;
        
        const touchobj = e.changedTouches[0];
        distX = touchobj.pageX - startX;
        distY = touchobj.pageY - startY;
        elapsedTime = new Date().getTime() - startTime;
        
        if (elapsedTime <= allowedTime && Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) {
          if (distX > 0 && Math.abs(distX) > Math.abs(distY)) {
            // Swipe right - go to previous
            this.goToPrevious();
          } else if (distX < 0 && Math.abs(distX) > Math.abs(distY)) {
            // Swipe left - go to next
            this.goToNext();
          }
        }
        
        isSwiping = false;
      }, { passive: false });

      // Mouse drag support for desktop
      let isDragging = false;
      let mouseStartX = 0;
      let mouseMoved = false;

      this.mainGallery.addEventListener('mousedown', (e) => {
        if (this.isTransitioning) return;
        isDragging = true;
        mouseStartX = e.pageX;
        mouseMoved = false;
        this.mainGallery.style.cursor = 'grabbing';
        e.preventDefault();
      });

      this.mainGallery.addEventListener('mousemove', (e) => {
        if (!isDragging || this.isTransitioning) return;
        mouseMoved = true;
        e.preventDefault();
      });

      this.mainGallery.addEventListener('mouseup', (e) => {
        if (!isDragging) return;
        isDragging = false;
        this.mainGallery.style.cursor = '';
        
        if (mouseMoved) {
          const distX = e.pageX - mouseStartX;
          if (Math.abs(distX) >= threshold) {
            if (distX > 0) {
              this.goToPrevious();
            } else {
              this.goToNext();
            }
          }
        }
        mouseMoved = false;
      });

      this.mainGallery.addEventListener('mouseleave', () => {
        isDragging = false;
        mouseMoved = false;
        this.mainGallery.style.cursor = '';
      });

      // Prevent context menu on long press
      this.mainGallery.addEventListener('contextmenu', (e) => {
        if (mouseMoved) {
          e.preventDefault();
        }
      });
    }

    switchToMedia(index) {
      if (this.isTransitioning || index === this.currentIndex) return;
      
      this.setActiveMedia(index);
      this.currentIndex = index;
    }

    goToNext() {
      const nextIndex = (this.currentIndex + 1) % this.mediaItems.length;
      this.switchToMedia(nextIndex);
    }

    goToPrevious() {
      const prevIndex = (this.currentIndex - 1 + this.mediaItems.length) % this.mediaItems.length;
      this.switchToMedia(prevIndex);
    }

    setActiveMedia(index) {
      if (this.isTransitioning || index < 0 || index >= this.mediaItems.length || index === this.currentIndex) return;
      
      this.isTransitioning = true;
      
      const currentMedia = this.mediaItems[index];
      const currentThumbnail = this.thumbnails[index];
      
      // Remove active class from all media items, thumbnails, and indicators
      this.mediaItems.forEach(item => {
        item.classList.remove('is-active');
      });
      
      this.thumbnails.forEach(thumb => {
        thumb.classList.remove('is-active');
      });

      this.indicators.forEach(indicator => {
        indicator.classList.remove('is-active');
      });
      
      // Add active class to current media, thumbnail, and indicator
      if (currentMedia) {
        currentMedia.classList.add('is-active');
        
        // Handle deferred media (videos, 3D models)
        const deferredMedia = currentMedia.querySelector('.deferred-media');
        if (deferredMedia) {
          const poster = deferredMedia.querySelector('.deferred-media__poster');
          if (poster && !deferredMedia.getAttribute('loaded')) {
            poster.click();
          }
        }
      }
      
      if (currentThumbnail) {
        currentThumbnail.classList.add('is-active');
      }

      // Update indicator
      const currentIndicator = this.indicators[index];
      if (currentIndicator) {
        currentIndicator.classList.add('is-active');
      }
      
      this.currentIndex = index;
      
      // Update slider counter if it exists
      if (this.counterCurrent) {
        this.counterCurrent.textContent = index + 1;
      }
      
      // Reset transition flag after CSS transition completes
      setTimeout(() => {
        this.isTransitioning = false;
      }, 400);
    }

    // Method to be called when media changes from external sources
    updateActiveFromMedia(mediaElement) {
      const mediaIndex = Array.from(this.mediaItems).indexOf(mediaElement);
      if (mediaIndex !== -1) {
        this.setActiveMedia(mediaIndex);
      }
    }
  });
}

// Global function to handle external media changes
window.updateProductThumbnails = function(mediaElement) {
  const thumbnailComponent = document.querySelector('product-thumbnails');
  if (thumbnailComponent && thumbnailComponent.updateActiveFromMedia) {
    thumbnailComponent.updateActiveFromMedia(mediaElement);
  }
};



